import { mapGetters, mapState } from 'vuex'
const runtimeConfig = require('../../functions/src/config/rtc.json')

export default {
  beforeCreate() {
    this.NODE_ENV = process.env.NODE_ENV
    this.ENV = runtimeConfig.app.env

    if (this.$options.name && this.$options.name[0] === this.$options.name[0].toUpperCase()) {
      this.mapState = mapState
      this.mapGettersOrig = mapGetters
    }

    this.dispatchActions = function (actions) {
      return Promise.all(actions.map((action) => this.$store.dispatch(action)))
    }

    this.mapStates = function (stateProps) {
      this.$options.computed = {
        ...this.$options.computed,
        ...this.mapState(stateProps.reduce((acc, stateProp) => {
          var compProp

          if (Array.isArray(stateProp)) {
            [compProp, stateProp] = stateProp
          } else {
            compProp = stateProp
          }

          acc[compProp] = state => state[stateProp]
          return acc
        }, {})
        )
      }
    }

    this.mapGetters = function (getterProps) {
      this.$options.computed = {
        ...this.$options.computed,
        ...this.mapGettersOrig(getterProps)
      }
    }
  }
}
